module.exports = __webpack_public_path__ + "media/Statue_Pain_Cam02.mp4";